import "@sass/theme.scss";
import CwLoadModules from "@customjs/module-loader.js";
import CwThemeFramework from "@customjs/generalFns.js";

/**
 * Running mixed functions across the theme
 */
CwThemeFramework.generalFns();

/**
 * Bootstrap Tabs
 */
const tabs = document.querySelector('[role="tablist"]');

if (tabs) CwLoadModules.Tabs();

/**
 * Popovers
 */

const popover = Array.from(
  document.querySelectorAll('[data-bs-toggle="popover"]')
);

if (popover.length) {
  const popoverTemplate = `<div class="popover" role="tooltip"><div class="popover-close" tabindex="0"></div><div class="popover-arrow"></div><h3 class="popover-header"></h3><div class="popover-body"></div></div>`;
  CwLoadModules.Popover().then((popoverModule) => {
    popover.map((popoverTriggerEl) => {
      return new popoverModule(popoverTriggerEl, {
        template: popoverTemplate,
        content: document.querySelector(
          popoverTriggerEl.dataset.popoverContent
        ),
      });
    });

    popover.forEach((e) => {
      e.addEventListener("shown.bs.popover", (ev) => {
        const currentPopoverCaller = ev.target;
        const currentPopover = document.querySelector(".popover.show");
        const closeBtn = currentPopover.querySelector(".popover-close");
        closeBtn.addEventListener("click", (ev) => {
          popoverModule.getInstance(currentPopoverCaller).hide();
        });
      });
    });
  });
}

/**
 * Dropdown
 */
const dropdown = document.querySelector(".dropdown-toggle");
if (dropdown) CwLoadModules.Dropdown();

/**
 * Accordions
 */
const accordion = document.querySelector(".accordion");

if (accordion) CwLoadModules.Collapse();

/**
 * Service Worker
 */
// check if service worker is available
if ("serviceWorker" in navigator) {
  document.addEventListener("DOMContentLoaded", () => {
    // Registering Service Worker
    navigator.serviceWorker
      // eslint-disable-next-line no-undef
      .register(`${childThemeURL}/sw.php`, {
        scope: "/",
      })
      .then((reg) => console.log(reg.scope))
      .catch((error) => console.log(error.message));
  });
}

/**
 * Loading Mobile Menu
 */

function matchMobile() {
  const mobileMediaQuery = window.matchMedia("(max-width: 768px)");
  return mobileMediaQuery.matches;
}

matchMobile() ? CwThemeFramework.mobileMenu() : "";

window.addEventListener("resize", () => {
  matchMobile() ? CwThemeFramework.mobileMenu() : "";
});

/**
 * Loading Modals in the Page
 * We will be pulling all the buttons with the data-cw-target
 * Attribute in order to initialize all the modals.
 */

// Checking for all out buttons
const modals = document.querySelectorAll("[data-cw-target]");

if (modals.length) {
  const modalInstances = [];
  CwLoadModules.modals().then((CwModals) => {
    modals.forEach((modalBtn, index) => {
      modalInstances[index] = new CwModals(".cw-modals");
      modalInstances[index].init();
    });
  });
}

/**
 * Loading Swiper JS
 * https://swiperjs.com/
 */
const carouselModules = {
  "testimonials-wrap-container": "testimonials-wrap-carousel",
  steps: "steps-slide",
};

// eslint-disable-next-line no-restricted-syntax
for (const [key, value] of Object.entries(carouselModules)) {
  const name = document.getElementById(key);
  if (name) {
    CwLoadModules.swiperSliders(value).then((module) => {
      module.default();
    });
  }
}

/**
 * Table of Contents
 * https://github.com/bfiessinger/Easy-TOC/
 */
const toc = document.getElementById("toc");

if (toc) {
  CwLoadModules.TableofContents().then((cwTOC) => {
    cwTOC.createTOC();
  });
}

/**
 * Loading MatchHeight
 * https://github.com/tannerhodges/match-height
 */

const matchElement = document.querySelectorAll("[data-match-height]");
if (matchElement.length) {
  setTimeout(() => {
    CwLoadModules.matchHeightLib();
  }, 200);
}

/**
 * Smooth Scroll
 * add class '.scroll' to new elements
 * class '.scroll' already added to footer back to top and TOC dynamic link elements
 */
// smooth scroll
document.addEventListener(
  "click",
  (event) => {
    if (!event.target.closest(".scroll")) return;

    const hashValue = event.target.closest(".scroll").getAttribute("href");
    const target = document.querySelector(hashValue);

    target.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
    history.pushState(null, null, hashValue);
    event.preventDefault();
  },
  false
);

// Pricing package monthly or yearly
const time = document.querySelectorAll(".period .btn");
if (time.length) {
  time.forEach((tag) => {
    tag.addEventListener("click", (event) => {
      // activate or deactive the button class
      var node = tag.parentNode.firstChild;

      while (node) {
        if (node !== this && node.nodeType === Node.ELEMENT_NODE)
          node.classList.remove("active");
        node = node.nextElementSibling || node.nextSibling;
      }
      tag.classList.add("active");

      // showing the prices
      let packagesInfo = document.querySelectorAll(".package-primary");
      packagesInfo.forEach((packageInfo) => {
        node = packageInfo.firstChild;
        while (node) {
          if (node.nodeType === Node.ELEMENT_NODE) {
            if (node.classList.contains(tag.dataset.time)) {
              node.classList.add("active");
            } else {
              node.classList.remove("active");
            }
          }
          node = node.nextElementSibling || node.nextSibling;
        }
      });

      // Adding the payment period to the button
      let buttonChoose = document.querySelectorAll(".btn-choose");
      buttonChoose.forEach((button) => {
        let href = button.href;

        button.href =
          href.substring(0, href.lastIndexOf("/")) + "/" + tag.dataset.time;
      });
    });
  });
}

// ReadOnly attributes for gravity forms
const gfInputs = document.querySelectorAll(".gf-readonly input");
if (gfInputs.length) {
  gfInputs.forEach((gfInput) => {
    gfInput.setAttribute("readonly", true);
  });
}
